import "dayjs/locale/uk";

import { useContext, useEffect, useState } from "react";

import Checkbox from "antd/lib/checkbox";
import DatePicker from "antd/lib/date-picker";
import Directories from "../../../../../../directories";
import Drawer from "../../../../../../ui/drawer";
import Form from "antd/lib/form";
import { FormContext } from "../../../../../../../contexts/form/index.context";
import Input from "antd/lib/input";
import InputNumber from "antd/lib/input-number";
import { MergedColumnType } from "../../../../../../ui/table/utils/types";
import { ModalContext } from "../../../../../../../contexts/modal/index.context";
import Select from "antd/lib/select";
import { SessionContext } from "../../../../../../../contexts/session/index.context";
import Space from "antd/lib/space";
import { TableContext } from "../../../../../../../contexts/table/index.context";
import { TranslationContext } from "../../../../../../../contexts/translation/index.context";
import Typography from "antd/lib/typography";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import { request } from "../../../../../../../services";
import styles from "../styles.module.scss";
import { useLocation } from "react-router-dom";
import { DrawerProvider } from "../../../../../../../contexts/drawer/index.context";

import en from "antd/es/date-picker/locale/en_US";
import ua from "antd/es/date-picker/locale/uk_UA";

//Components

//UI

//Locale

dayjs.extend(customParseFormat);
dayjs.locale("uk");

const { Title } = Typography;

type FormItemConfig = {
  [key: string]: { label: string; name: string }[];
};

const formItemConfig: FormItemConfig = {
  "/directories/profession-classifier": [
    { label: "kp", name: "kp" },
    { label: "okp", name: "okp" },
    { label: "etks", name: "etks" },
  ],
  "/directories/job-categories": [{ label: "code", name: "code" }],
  "/directories/types-of-structural-unit": [
    { label: "code", name: "code" },
    { label: "notes", name: "notes" },
  ],
};

// Код для «Довідники» - розділ «Відділ кадрів» модальна форма

export function HrDepartment({ pathname }: { pathname: string }) {
  // console.log("HrDepartment logs ", pathname);
  const { intl } = useContext(TranslationContext);
  const config = formItemConfig[pathname];

  return (
    <>
      {pathname !== "/directories/job-categories" ? (
        <>
          <Form.Item
            label={intl("name")}
            name="name"
            rules={[
              {
                required: true,
                message: intl("name-required"),
              },
            ]}
          >
            <Input />
          </Form.Item>
          {config &&
            config.map((item, i) => (
              <Form.Item
              key={i}
                label={intl(item.label)}
                name={item.name}
                rules={[
                  {
                    max:
                      item.name === "okp"
                        ? 5
                        : item.name === "notes"
                        ? 500
                        : 20,
                    message: intl("the-number-of-allowed"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            ))}
        </>
      ) : (
        <>
          {config &&
            config.map((item) => (
              <Form.Item
                label={intl(item.label)}
                name={item.name}
                rules={[
                  {
                    pattern: /^\d+$/,
                    message: intl("only-digits"),
                  },
                  {
                    max:
                      item.name === "okp"
                        ? 5
                        : item.name === "notes"
                        ? 500
                        : 20,
                    message: intl("the-number-of-allowed"),
                  },
                ]}
              >
                <Input />
              </Form.Item>
            ))}
          <Form.Item
            label={intl("name")}
            name="name"
            rules={[
              {
                required: true,
                message: intl("name-required"),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </>
      )}
    </>
  );
}

export function StructuralUnits({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const [subdivisionId, setSubdivisionId] = useState<number | undefined>(edit ? sessionData.sta_type_subdivision_id : undefined);
  const [refersToId, setRefersToId] = useState<number | undefined>(edit ? sessionData.parent_id : undefined);
  const [reorganizedId, setReorganizedId] = useState<number | undefined>(edit ? sessionData.reorganize_otdel_id : undefined);

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/types-of-structural-unit"]) {
        fieldsValue.subdivision =
          rowData["/directories/types-of-structural-unit"].id;
          setSubdivisionId(rowData["/directories/types-of-structural-unit"].id);
      }
      if (rowData["/directories/structural-units/refersTo"]) {
        fieldsValue.refersTo =
          rowData["/directories/structural-units/refersTo"].id;
          setRefersToId(rowData["/directories/structural-units/refersTo"].id);
      }
      if (rowData["/directories/structural-units/reorganized"]) {
        fieldsValue.reorganized =
          rowData["/directories/structural-units/reorganized"].id;
          setReorganizedId(rowData["/directories/structural-units/reorganized"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  return (
    <>
      <DrawerProvider>
      <Form.Item label={intl("code")} name="code" rules={[{ max: 5 }]}>
        <Input />
      </Form.Item>
      <Form.Item label={intl("type2")} name="subdivision">
        <Drawer
          url="/directories/types-of-structural-unit"
          name={edit ? sessionData.name_subdivision : undefined}
          name2={rowData["/directories/types-of-structural-unit"]?.data.Name}
          setFormFields={setFormFields}
          fieldName={"subdivision"}
        >
          <Directories url="/directories/types-of-structural-unit" selectedRowId={subdivisionId}/>
        </Drawer>
      </Form.Item>
      <Form.Item
        label={intl("full-name")}
        name="department"
        rules={[
          {
            required: true,
            message: intl("full-name-required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={intl("short-name")} name="shortName">
        <Input />
      </Form.Item>
      <Form.Item label={intl("refers-to")} name="refersTo">
        <Drawer
          url="/directories/structural-units"
          name={edit ? sessionData.NameParent : undefined}
          name2={rowData["/directories/structural-units/refersTo"]?.data.Name}
          setFormFields={setFormFields}
          fieldName={"refersTo"}
        >
          <Directories url="/directories/structural-units" name="refersTo" selectedRowId={refersToId}/>
        </Drawer>
      </Form.Item>
      <Form.Item label={intl("reorganized-into")} name="reorganized">
        <Drawer
          url="/directories/structural-units"
          name={edit ? sessionData.NameReorg : undefined}
          name2={
            rowData["/directories/structural-units/reorganized"]?.data.Name
          }
          setFormFields={setFormFields}
          fieldName={"reorganized"}
        >
          <Directories url="/directories/structural-units" name="reorganized" selectedRowId={reorganizedId}/>
        </Drawer>
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
      <Form.Item name="isLiquidated" valuePropName="checked">
        <Checkbox>{intl("liquidated")}</Checkbox>
      </Form.Item>
      </DrawerProvider>
    </>
  );
}

export function Positions({ pathname }: { pathname: string }) {
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const [categorySelId, setCategorySelId] = useState<number | undefined>(edit ? sessionData.KATEG_ID : undefined);
  const [nameProfSelId, setNameProfSelId] = useState<number | undefined>(edit ? sessionData.PROF_id : undefined);

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/job-categories"]) {
        fieldsValue.category = rowData["/directories/job-categories"].id;
        setCategorySelId(rowData["/directories/job-categories"].id);
      }
      if (rowData["/directories/profession-classifier"]) {
        fieldsValue.nameProf = rowData["/directories/profession-classifier"].id;
        setNameProfSelId(rowData["/directories/profession-classifier"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }
  return (
    <>
      <DrawerProvider>
        <Form.Item label={intl("category")} name="category">
          <Drawer
            url="/directories/job-categories"
            name={edit ? sessionData.KATEGORIA : undefined}
            name2={rowData["/directories/job-categories"]?.data.Name}
            setFormFields={setFormFields}
            fieldName={"category"}
          >
            <Directories url="/directories/job-categories" selectedRowId={categorySelId} />
          </Drawer>
        </Form.Item>
        <Form.Item label={intl("code")} name="code" rules={[{ max: 20 }]}>
          <Input />
        </Form.Item>
        <Form.Item label={intl("profession-classifier")} name="nameProf">
            <Drawer
              url="/directories/profession-classifier"
              name={edit ? sessionData.NameProf : undefined}
              name2={rowData["/directories/profession-classifier"]?.data.Name}
              setFormFields={setFormFields}
              fieldName={"nameProf"}
            >
              <Directories url="/directories/profession-classifier" selectedRowId={nameProfSelId} />
            </Drawer>
        </Form.Item>
        <Form.Item
          label={intl("position")}
          name="position"
          rules={[
            {
              required: true,
              message: intl("position-required"),
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item label={intl("description")} name="description">
          <Input />
        </Form.Item>
      </DrawerProvider>
      </>
  );
}

export function EmployeesAndContactPersons({ pathname }: { pathname: string }) {
  // console.log("EmployeesAndContactPersons component");
  const location = useLocation();
  const { intl, language } = useContext(TranslationContext);

  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { rowData } = useContext(TableContext);
  const { sessionData } = useContext(SessionContext);
  const edit = activeModal === "edit";
  const dateFormatList = ["DD.MM.YYYY", "DD-MM-YYYY"];
  const [positionSelId, setPositionSelId] = useState<number | undefined>(edit ? sessionData.posada_id : undefined);
  const [enterpriseOrganizationId, setEnterpriseOrganizationId] = useState<number | undefined>(edit ? sessionData.sta_kontragent_id : undefined);
  const [structuralUnitId, setStructuralUnitId] = useState<number | undefined>(edit ? sessionData.otdel_id : undefined);

  const isContactPersonOrNonClerkEdit =
    activeModal === "contact-person" ||
    (activeModal === "edit" && !sessionData.is_clerk);

  const formItemData = isContactPersonOrNonClerkEdit
    ? {
        label: "enterprise-organization",
        name: "enterpriseOrganization",
        url: "/directories/correspondents",
      }
    : {
        label: "structural-unit",
        name: "structuralUnit",
        url: "/directories/structural-units",
      };

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/correspondents"]) {
        fieldsValue.enterpriseOrganization =
          rowData["/directories/correspondents"].id;
          setEnterpriseOrganizationId(rowData["/directories/correspondents"].id);
      }
      if (rowData["/directories/structural-units"]) {
        fieldsValue.structuralUnit =
          rowData["/directories/structural-units"].id;
          setStructuralUnitId(rowData["/directories/structural-units"].id);
      }
      if (rowData["/directories/positions"]) {
        fieldsValue.position = rowData["/directories/positions"].id;
        setPositionSelId(rowData["/directories/positions"].id);
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  function isLeapYear(year: number) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  const getDaysInMonth = (month: number, year: number) => {
    if (month === 2) {
      return isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      return 30;
    } else {
      return 31;
    }
  };

  const handleMonthChange = (value: string) => {
    form.setFieldsValue({ monthBirth: value });
    const month = parseInt(value);
    const year = form.getFieldValue("yearBirth");
    if (year) {
      const maxDay = getDaysInMonth(month, year);
      const day = form.getFieldValue("dayBirth");
      day &&
        form.setFieldsValue({
          dayBirth: Math.min(maxDay, form.getFieldValue("dayBirth")),
        });
    }
  };

  const handleYearChange = (event: any) => {
    const year = parseInt(event.target.value);
    const month = parseInt(form.getFieldValue("monthBirth"));
    if (month) {
      const maxDay = getDaysInMonth(month, year);
      const day = form.getFieldValue("dayBirth");
      day &&
        form.setFieldsValue({
          dayBirth: Math.min(maxDay, form.getFieldValue("dayBirth")),
        });
    }
  };

  return (
    <>
      <DrawerProvider>
      <Form.Item label={intl(formItemData.label)} name={formItemData.name}>
        <Drawer
          url={formItemData.url}
          name={
            edit
              ? !sessionData.is_clerk
                ? sessionData.sta_kontragent_name
                : sessionData.name_otdel
              : undefined
          }
          name2={
            isContactPersonOrNonClerkEdit
              ? rowData["/directories/correspondents"]?.data.Name
              : rowData["/directories/structural-units"]?.data.Name
          }
          setFormFields={setFormFields}
          fieldName={formItemData.name}
        >
          <Directories url={formItemData.url} selectedRowId={isContactPersonOrNonClerkEdit? enterpriseOrganizationId : structuralUnitId}/>
        </Drawer>
      </Form.Item>
      {isContactPersonOrNonClerkEdit && (
        <Form.Item label={intl("structural-unit")} name="structuralUnit2">
          <Input />
        </Form.Item>
      )}
      <Form.Item label={intl("position")} name="position">
        <Drawer
          url="/directories/positions"
          name={edit ? sessionData.posada : undefined}
          name2={rowData["/directories/positions"]?.data.Name}
          setFormFields={setFormFields}
          fieldName={"position"}
        >
          <Directories url="/directories/positions" selectedRowId={positionSelId}  />
        </Drawer>
      </Form.Item>
      <Title level={4}>{intl("personal-data")}</Title>
      <Form.Item
        label={intl("last-name")}
        name="lastName"
        rules={[
          {
            required: true,
            message: intl("last-name-required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        label={intl("first-name")}
        name="firstName"
        rules={[
          {
            required: true,
            message: intl("first-name-required"),
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Item label={intl("middle-name")} name="middleName">
        <Input />
      </Form.Item>
      {isContactPersonOrNonClerkEdit ? (
        <Space className={styles["space"]} size={"large"}>
          <Form.Item label={intl("date-birth")} name="birthday">
            <DatePicker
              format={dateFormatList}
              placeholder={intl("choose-date-placeholder")}
              locale={language ? ua : en}
            />
          </Form.Item>
          <Form.Item label={intl("for-envelopes")} name="forEnvelopes">
            <Input />
          </Form.Item>
        </Space>
      ) : (
        <>
          <Space className={styles["space"]} size={"large"}>
            <Form.Item
              label={intl("year-birth")}
              name="yearBirth"
              rules={[
                // { max: 4 },
                () => ({
                  validator(_, value) {
                    if (
                      !value ||
                      (value >= 1900 && value <= new Date().getFullYear())
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(intl("year-of-birth-was-entered-incorrectly"))
                    );
                  },
                }),
              ]}
            >
              <Input onChange={handleYearChange} />
            </Form.Item>
            <Form.Item label={intl("month-birth")} name="monthBirth">
              <Select
                // defaultValue={intl("january")}
                onChange={handleMonthChange}
                options={[
                  { value: "1", label: intl("january") },
                  { value: "2", label: intl("february") },
                  { value: "3", label: intl("march") },
                  { value: "4", label: intl("april") },
                  { value: "5", label: intl("may") },
                  { value: "6", label: intl("june") },
                  { value: "7", label: intl("july") },
                  { value: "8", label: intl("august") },
                  { value: "9", label: intl("september") },
                  { value: "10", label: intl("october") },
                  { value: "11", label: intl("november") },
                  { value: "12", label: intl("december") },
                ]}
              />
            </Form.Item>
            <Form.Item
              label={intl("day-birth")}
              name="dayBirth"
              rules={[
                () => ({
                  validator(_, value) {
                    // if (!value || (value >= 1 && value <= 31)) {
                    //   return Promise.resolve();
                    // }
                    // return Promise.reject(
                    //   new Error(intl("number-must-be-between"))
                    // );
                    const month = parseInt(form.getFieldValue("monthBirth"));
                    const year = parseInt(form.getFieldValue("yearBirth"));
                    if (!value || !month || !year) {
                      return Promise.resolve();
                    }
                    const maxDay = getDaysInMonth(month, year);
                    if (value >= 1 && value <= maxDay) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(`${intl("number-must-be-between")}${maxDay}`)
                    );
                  },
                }),
              ]}
            >
              <Input />
            </Form.Item>
          </Space>
          <Form.Item label={intl("for-envelopes")} name="forEnvelopes">
            <Input />
          </Form.Item>
        </>
      )}
      <Title level={4}>{intl("contact-information")}</Title>
      <Space className={styles["space"]} size={"large"}>
        <Form.Item label={intl("telephone")} name="telephone">
          <Input />
        </Form.Item>
        <Form.Item label={intl("fax")} name="fax">
          <Input />
        </Form.Item>
      </Space>
      <Space className={styles["space"]} size={"large"}>
        <Form.Item label={intl("mobile-phone")} name="mobilePhone">
          <Input />
        </Form.Item>
        <Form.Item label={intl("email")} name="email">
          <Input />
        </Form.Item>
      </Space>
      <Form.Item label={intl("no-cabinet")} name="noCabinet">
        <Input
          disabled={
            isContactPersonOrNonClerkEdit /* ||
            props.data?.type_rec === 1 */ && true
          }
        />
      </Form.Item>
      <Title level={4}>{intl("signs")}</Title>
      <Space size={"large"}>
        <Form.Item name="head" valuePropName="checked">
          <Checkbox>{intl("head")}</Checkbox>
        </Form.Item>
        <Form.Item name="rightControl" valuePropName="checked">
          <Checkbox
            disabled={
              isContactPersonOrNonClerkEdit /* || props.data?.type_rec === 1 */ &&
              true
            }
          >
            {intl("right-control")}
          </Checkbox>
        </Form.Item>
        <Form.Item name="released" valuePropName="checked">
          <Checkbox>{intl("released")}</Checkbox>
        </Form.Item>
      </Space>
      </DrawerProvider>
      </>
  );
}

export function DepartmentalJournals({ pathname }: { pathname: string }) {
  const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  const { activeModal } = useContext(ModalContext);
  const { sessionData } = useContext(SessionContext);
  const { rowData } = useContext(TableContext);
  const edit = activeModal === "edit";
  const [structuralUnitData, setStructuralUnitData] = useState<
    MergedColumnType[]
  >([]);

  const newStructuralUnit = structuralUnitData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  function setFormFields() {
    if (/* edit &&  */ rowData) {
      const fieldsValue: any = {};
      if (rowData["/directories/job-categories"]) {
        fieldsValue.category = rowData["/directories/job-categories"].id;
      }
      if (rowData["/directories/profession-classifier"]) {
        fieldsValue.nameProf = rowData["/directories/profession-classifier"].id;
      }
      form.setFieldsValue(fieldsValue);
    }
  }

  const fetchStructuralUnitData = async () => {
    const content = (
      await request(`${pathname}/getdataselect`, {
        method: "get",
        cancelTokenKey: "getdataselect",
      })
    )?.content;
    setStructuralUnitData(content || []);
  };

  return (
    <>
      <Form.Item label={intl("structural-unit")} name="structuralUnit">
        <Select
          onChange={(_, value) => {
            form.setFieldsValue({ structuralUnit: value });
          }}
          onDropdownVisibleChange={fetchStructuralUnitData}
          options={newStructuralUnit}
          allowClear
        />
      </Form.Item>
      <Title level={5}>{intl("journal")}</Title>
      <Form.Item label={intl("code")} name="code">
        <Input />
      </Form.Item>
      <Form.Item label={intl("name")} name="name">
        <Input />
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
      <Space className={styles.rowCheckBox}>
        <Form.Item name="incoming" valuePropName="checked">
          <Checkbox>{intl("incoming")}</Checkbox>
        </Form.Item>
        <Form.Item name="incomingText">
          <InputNumber min={0} step={1} />
        </Form.Item>
        <Form.Item name="outcoming" valuePropName="checked">
          <Checkbox>{intl("outcoming")}</Checkbox>
        </Form.Item>
        <Form.Item name="outcomingText">
          <InputNumber min={0} step={1} />
        </Form.Item>
        <Form.Item name="internal" valuePropName="checked">
          <Checkbox>{intl("internal")}</Checkbox>
        </Form.Item>
        <Form.Item name="internalText">
          <InputNumber min={0} step={1} />
        </Form.Item>
        <Form.Item name="citizensAppeal" valuePropName="checked">
          <Checkbox>{intl("citizens-appeal")}</Checkbox>
        </Form.Item>
      </Space>
      <Title level={5}>{intl("parameters")}</Title>
      <Form.Item
        name="setByDefaultWhenRegisteringDocuments"
        valuePropName="checked"
      >
        <Checkbox>{intl("set-by-default-when-registering-documents")}</Checkbox>
      </Form.Item>
      <Form.Item name="displayingDataFromWebService" valuePropName="checked">
        <Checkbox>{intl("displaying-data-from-a-web-service")}</Checkbox>
      </Form.Item>
      <Form.Item
        name="doNotDisplayInTheGeneralRegister"
        valuePropName="checked"
      >
        <Checkbox>{intl("do-not-display-in-the-general-register")}</Checkbox>
      </Form.Item>
      <Form.Item
        name="doNotDisplayTheJournalCodeInTheCard"
        valuePropName="checked"
      >
        <Checkbox>
          {intl("do-not-display-the-journal-code-in-the-card")}
        </Checkbox>
      </Form.Item>
      <Form.Item
        name="setByDefaultWhenRegisteringFromTheMainOffice"
        valuePropName="checked"
      >
        <Checkbox>
          {intl("set-by-default-when-registering-from-the-main-office")}
        </Checkbox>
      </Form.Item>
      <Title level={5}>
        {intl("include-in-the-number-for-citizens-to-contact")}
      </Title>
      <Space>
        <Form.Item name="firstLetterOther" valuePropName="checked">
          <Checkbox>{intl("first-letter-other")}</Checkbox>
        </Form.Item>
        <Form.Item name="journalCode" valuePropName="checked">
          <Checkbox>{intl("journal-code")}</Checkbox>
        </Form.Item>
      </Space>
      <Form.Item name="receiptFormCodeAlternative" valuePropName="checked">
        <Checkbox>{intl("receipt-form-code-alternative")}</Checkbox>
      </Form.Item>
      <Space>
        <Form.Item name="applicationForm" valuePropName="checked">
          <Checkbox>{intl("application-form")}</Checkbox>
        </Form.Item>
        <Form.Item name="mainApplicationForm" valuePropName="checked">
          <Checkbox>{intl("main-application-form")}</Checkbox>
        </Form.Item>
      </Space>
      <Form.Item
        name="receiptFormCodeAlternativeJournalCode"
        valuePropName="checked"
      >
        <Checkbox>
          {intl("receipt-form-code-alternative-journal-code")}
        </Checkbox>
      </Form.Item>
      <Form.Item name="moveTheIndexOfTheHit" valuePropName="checked">
        <Checkbox>{intl("move-the-index-of-the-hit")}</Checkbox>
      </Form.Item>
      <Title level={5}>{intl("re-registration-options")}</Title>
      <Form.Item
        name="doNotReRegisterWithoutAnEmailSignature"
        valuePropName="checked"
      >
        <Checkbox>
          {intl("do-not-re-register-without-an-email-signature")}
        </Checkbox>
      </Form.Item>
      <Form.Item
        name="doNotDisplayWithoutEmailSignature"
        valuePropName="checked"
      >
        <Checkbox>{intl("do-not-display-without-email-signature")}</Checkbox>
      </Form.Item>
      <Form.Item
        name="whenReRegisteringFromTheMainOffice"
        valuePropName="checked"
      >
        <Checkbox>{intl("when-re-registering-from-the-main-office")}</Checkbox>
      </Form.Item>
      <Form.Item
        name="offerToApplyBarcodeToCEBDocuments"
        valuePropName="checked"
      >
        <Checkbox>{intl("offer-to-apply-a-barcode-to-ceb-documents")}</Checkbox>
      </Form.Item>
      <Form.Item name="offerToApplyBarcode" valuePropName="checked">
        <Checkbox>{intl("offer-to-apply-barcode")}</Checkbox>
      </Form.Item>
    </>
  );
}

export function GroupsOfCorrespondents({ pathname }: { pathname: string }) {
  // const location = useLocation();
  const { intl } = useContext(TranslationContext);
  const { form } = useContext(FormContext);
  // const { activeModal } = useContext(ModalContext);
  // const { sessionData } = useContext(SessionContext);
  // const { rowData } = useContext(TableContext);
  // const edit = activeModal === "edit";
  const [staOtdelData, setStaOtdelData] = useState<MergedColumnType[]>([]);
  const staOtdel = staOtdelData.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const fetchStructuralUnitData = async () => {
    const content = (
      await request(`${pathname}/getdataselect`, {
        method: "get",
        cancelTokenKey: "getdataselect",
      })
    )?.content;
    setStaOtdelData(content || []);
  };

  return (
    <>
      {/* <Title level={5}>{intl("journal")}</Title> */}
      <Form.Item label={intl("code")} name="code">
        <Input />
      </Form.Item>
      <Form.Item label={intl("name")} name="name">
        <Input />
      </Form.Item>
      <Form.Item label={intl("office-department")} name="staOtdel">
        <Select
          onChange={(_, value) => {
            form.setFieldsValue({ staOtdel: value });
          }}
          onDropdownVisibleChange={fetchStructuralUnitData}
          options={staOtdel}
          allowClear
        />
      </Form.Item>
      <Form.Item label={intl("notes")} name="notes">
        <Input />
      </Form.Item>
    </>
  );
}
